(function (window, document, undefined) {
  'use strict';

  let Vue = window.Vue || false,
    forumData = {},
    commentData = {},
    userStatus,
    logger;

  /**
   * Renders the forum component in the specified wrapper element.
   *
   * This function initializes a Vue.js app to render a forum component within
   * a designated HTML element. The forum component is sourced from the
   * "@russmedia-frontend/np-forum" library. It is passed various properties
   * required for configuring the forum, such as postId, ssoId, and commentData.
   *
   * @function renderForum
   * @global
  */
  const renderForum = () => {
    const forum = Vue.createApp({
      components: {
        Forum: window['@russmedia-frontend/np-forum'].Forum,
      },
      setup() {
        // i want to parse all cookies and search for a cookie named "evoSSO"
        // if it exists, i want to return the value of it

        let evoSSOCookie = '';
        let sessionCookie = '';
        document.cookie.split(';').forEach((cookie) => {
          cookie = cookie.trim();

          if (cookie.startsWith('EvoSSO=')) {
            evoSSOCookie = cookie.substring('EvoSSO='.length);
          }
          if (cookie.startsWith('SsoSessionCookie=')) {
            sessionCookie = cookie.substring('SsoSessionCookie='.length);
          }
        });

        return {
          postId: forumData.postId,
          sessionCookie: sessionCookie,
          evoSSOCookie: evoSSOCookie,
          userBlocked: userStatus?.commentBan,
          commentData,
        };
      },
      template: `<Forum
          :postId="postId"
          :sessionCookie="sessionCookie"
          :evoSSOCookie="evoSSOCookie"
          :commentData="commentData"
          :userBlocked="userBlocked"
        ></Forum>`,
    }).mount('#vodl-forum-wrapper');
  };

  /**
   * Load the comments and return a promise
   * @return {Promise} A promise object
   */
  function loadComments() {
    var rnd = Math.floor(Math.random() * 100000 + 1);
    var deferred = $.Deferred(),
      url =
        '/api/nnp/get_forum?rnd=' +
        rnd +
        '&p=' +
        forumData.postId +
        '&max_depth=99';

    $.ajax({
      type: 'GET',
      url: url,
    }).then(
      function (result) {
        result.status = result.status || false;
        result.comments = result.comments || [];
        result.forumEnabled = result.forumEnabled || false;
        result.paging = result.paging || {};

        if ('ok' === result.status) {
          deferred.resolve(result);
        } else {
          //failure, reject promise
          console.log('Error loading comments: ' + result.error);
          deferred.reject(result);
        }
      },
      function (jqXHR, textStatus, errorThrown) {
        //failure, reject promise
        console.log('Error loading comments: ' + errorThrown);
        deferred.reject(result);
      }
    );

    return deferred.promise();
  }

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The post data object on success, false otherwise.
   */
  const parseCommentData = function () {
    const forumDataNode = document.querySelector('#forumDataNode');

    let parsedCommentData = {};

    try {
      parsedCommentData = JSON.parse(forumDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedCommentData;
  };

  const _init = function () {
    try {
      logger = new window.RussMedia.Utils.Logger('[forum] ') || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log('_init: No Vue!');
      return;
    } else {
      logger.log('Load Vue component.');
    }

    forumData = parseCommentData();
    if (!forumData || !forumData.postId) {
      logger.log('_init: Missing forum data.');
      return;
    }

    commentData = {
      status: 'ok',
      forumEnabled:
        undefined !== forumData.forumOpen ? forumData.forumOpen : true,
      comments: [],
      paging: {},
    };

    //if the user is banned, hide the comment section
    userStatus = window.RussMedia.Utils.LocalStorage.get('user-status');

    if (commentData.forumEnabled) {
      loadComments()
        .then(
          function (result) {
            commentData = result;
            renderForum();
          },
          function () {
            console.log('[forum] loading comments failed');
          }
        );
    } else {
      logger.log('Forum is closed for this article.');
      renderForum();
    }
  };

  if (window.article.eoa || undefined === window.article.eoa) {
    console.log('[forum] init forum', '[eoa] window.article.eoa is ' + window.article.eoa );
    _init();
  } else {
    window.addEventListener('end_of_article', function () {
      console.log('[forum][eoa] init forum (lazy)');
      _init();
    });
  }

})(window, document);
